module.exports = __webpack_public_path__ + "img/papo-reto-maternidade.a0ca038c.svg";